import GoogleMark from 'shared/components/ui/GoogleMark';
import React from 'react';

/**
 * @param {'signin' | 'signup'} variant
 */
export default function GoogleAuthButton({ onClick, disabled, variant = 'signin' }) {
  const label = variant === 'signup' ? 'Sign up with Google' : 'Sign in with Google';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-full py-[10px] px-4 bg-[color:var(--surface-base)] hover:bg-[color:var(--surface-raised)] border border-[color:var(--border-default)] rounded-lg flex items-center justify-center gap-3 transition-colors text-[color:var(--text-primary)] text-[14px] font-medium disabled:opacity-50 disabled:pointer-events-none"
    >
      <GoogleMark size={20} />
      {label}
    </button>
  );
}
